import {
  OriginalSchedulesMenu,
  NewSchedulesMenu,
} from 'constant/ScheduleMenuConstant';

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

//compare if valueToCheck is in between values
export const isBetweenValues = (value1, value2, valueToCheck) => {
  return valueToCheck >= value1 && valueToCheck <= value2;
};

//convert string to int
export const convertToInt = (value) => {
  if (!value) return 0;
  if (!Number.isInteger(Number(value))) {
    return 0;
  } else {
    return parseInt(value);
  }
};

//check if empty object
export const isEmptyObject = (value) => {
  return (
    value &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    Object.keys(value).length === 0 &&
    value.constructor === Object
  );
};

export const getScheduleMenuType = (type) => {
  const menuType = (type || '').toLowerCase();

  if (menuType === NewSchedulesMenu) {
    return NewSchedulesMenu;
  }

  return OriginalSchedulesMenu;
};

// Expects number string, returns the same string seperated by commas
// For example: 1000000 -> 1,000,000
export const formatWithCommas = (value) => {
  if (value === null || value === undefined) return value;

  const stringValue = value.toString();

  // Handle decimals separately
  const [integerPart, decimalPart] = stringValue.split('.');

  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ','
  );

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
}